import { UseMutationOptions, useQueryClient } from 'react-query';
import produce from 'immer';

import { SetBlocklistMutation, SetBlocklistMutationVariables } from 'api';
import { GetBlocklistQuery, useGetBlocklistQuery } from 'api/public';
import { useCurrentUser, useNotify } from 'hooks';

type Mutation = SetBlocklistMutation;
type MutationVariables = SetBlocklistMutationVariables;
type QueryData = GetBlocklistQuery;

const useUpdateBlocklist = () => {
  const currentUser = useCurrentUser();
  const queryClient = useQueryClient();
  const queryKey = useGetBlocklistQuery.getKey({ client_id: currentUser.client_id });
  const notify = useNotify();

  const mutationOptions: UseMutationOptions<Mutation, unknown, MutationVariables> = {
    onMutate: async mutationArgs => {
      await queryClient.cancelQueries(queryKey);

      const baseState = queryClient.getQueryData<QueryData>(queryKey);
      const nextState =
        baseState &&
        produce(baseState, draftState => {
          draftState.getBlockList.terms = mutationArgs.terms as string[];
        });

      if (baseState) {
        queryClient.setQueryData<QueryData>(queryKey, nextState);
      }

      return baseState;
    },
    onError: (error, mutationArgs, baseState: QueryData) => {
      if (baseState) {
        queryClient.setQueryData<QueryData>(queryKey, baseState);
      }
      notify.mutationError();
    },
  };

  return mutationOptions;
};

export default useUpdateBlocklist;
